export interface Category {
  slug: string;
  name: string;
  tagline: string;
}

export interface Article {
  id: string;
  category: string;
  title: string;
  summary: string;
  author: string;
  date: string;
  readTime: string;
  tags: string[];
  image: string;
  featured?: boolean;
  hot?: boolean;
  body: { type: "p" | "h2"; text: string }[];
}

export interface Faq {
  q: string;
  a: string;
}

export const site = {
  name: "看料站",
  slogan: "热门内容，一站看全",
  contact: {
    email: "hello@kanliaozhan.example",
    wechat: "kanliao-daily",
  },
};

export const categories: Category[] = [
  { slug: "yingshi", name: "影视", tagline: "好剧好片，不再错过" },
  { slug: "yinyue", name: "音乐现场", tagline: "旋律与现场的灵感库" },
  { slug: "shenghuo", name: "生活方式", tagline: "把日子过出质感" },
  { slug: "wenhua", name: "文化社会", tagline: "看见时代的另一面" },
];

export const articles: Article[] = [
  {
    id: "autumn-healing-dramas",
    category: "yingshi",
    title: "秋冬追剧清单：这 6 部治愈系剧集，值得一个安静周末",
    summary: "从城市烟火到山野四季，这个秋冬不妨慢下来。我们挑选了六部节奏舒缓、后劲十足的治愈系作品，配好热茶与毯子，陪你度过一个不再焦虑的周末。",
    author: "林晚晴",
    date: "2026-09-03",
    readTime: "8 分钟",
    tags: ["追剧", "治愈系", "片单"],
    image:
      "https://readdy.ai/api/search-image?query=cozy%20autumn%20watching%20movies%20at%20home%20with%20warm%20blanket%20and%20tea%20by%20window%2C%20soft%20golden%20window%20light%2C%20cinematic%20editorial%20lifestyle%20photography%2C%20muted%20warm%20tones%2C%20film%20grain&width=1200&height=760&seq=card-yingshi-01&orientation=landscape",
    featured: true,
    hot: true,
    body: [
      { type: "p", text: "入秋之后，白天变短，夜里变长。比起催促自己向前跑，有些人更愿意留出一段完整的时光，看一部节奏恰好、情绪温和的作品。看料站在本期片单里，从现实题材、青春群像到公路与自然影像，选出六部值得慢看的治愈系剧集。" },
      { type: "h2", text: "都市人的情绪避风港" },
      { type: "p", text: "当代剧集里的都市感，不再只是写字楼与咖啡，而是更多落在真实的人际缝隙里。剧中的主角未必成功，却在一次次笨拙的尝试中，教会我们如何与家人和解、与自己和解。这类作品适合在加完班的夜里点开，看着看着，心就静了。" },
      { type: "h2", text: "让镜头替我们走一趟远方" },
      { type: "p", text: "还有几部把镜头对准了小城与乡村：麦田、老屋、灶台与赶集的人群。它们不贩卖奇观，只安静地记录普通人的四季流转。当你看惯了城市的霓虹，这样克制的画面反而更容易让人得到抚慰。" },
      { type: "p", text: "片单只是起点，真正动人的，永远是你在某句台词、某个镜头里看见自己的时刻。希望这份清单，能陪你度过一段被温柔对待的时间。" },
    ],
  },
  {
    id: "ban-gong-shi-zhuang-xiu",
    category: "shenghuo",
    title: "小户型改造实录：把 40㎡ 住出松弛感，关键在留白与收纳",
    summary: "不是面积小就只能将就。一位屋主分享了自己 40㎡ 一居室的改造全过程：减少硬装、强化收纳、给墙面留白，让小家既好打理又有呼吸感。",
    author: "陈一舟",
    date: "2026-09-01",
    readTime: "10 分钟",
    tags: ["家居", "小户型", "改造"],
    image:
      "https://readdy.ai/api/search-image?query=small%20apartment%20interior%20with%20light%20wood%2C%20white%20walls%20and%20clever%20storage%20solutions%2C%20airy%20minimal%20scandinavian%20style%2C%20warm%20natural%20daylight%2C%20editorial%20interior%20magazine%20photography&width=1200&height=760&seq=card-shenghuo-01&orientation=landscape",
    hot: true,
    body: [
      { type: "p", text: "「家里要能装下生活，也要能装下心情。」这是本期改造主人的口头禅。面对 40㎡ 的一居室，他没有选择堆满柜子，而是先做减法：拆掉多余隔断，让客餐厨连成一片；再用一组高柜和悬空收纳，把杂物悄悄藏进立面。" },
      { type: "h2", text: "留白，是空间最大的奢侈" },
      { type: "p", text: "改造中最难的不是增加，而是克制。墙面大部分留白，家具只保留高频使用的几件，视觉重心就落在了采光与窗外。屋主说，空间窄小不可怕，可怕的是没有呼吸的地方。" },
      { type: "h2", text: "收纳要“顺手”，不是“好看”" },
      { type: "p", text: "真正耐用的收纳，一定长在动线上：玄关留换鞋凳，厨房转角做拉篮，卧室床头一整面薄柜。把常用物放在伸手可及处，家才不会在每次找东西时重新乱起来。" },
      { type: "p", text: "如果你也住着小户型，不妨从「留一面白墙、收一路杂物」开始。家不必豪华，舒服就好。" },
    ],
  },
  {
    id: "gong-yi-yue-dui-ji-lu",
    category: "yinyue",
    title: "声浪现场：独立音乐巡演季观察，现场演出正在成为年轻人的新社交",
    summary: "从体育馆到 Livehouse，年轻人正在把周末留给一场演出。我们探访了几个城市的中小型现场，聊聊演出文化如何重塑社交与情绪出口。",
    author: "周野",
    date: "2026-08-29",
    readTime: "9 分钟",
    tags: ["音乐现场", "巡演", "文化"],
    image:
      "https://readdy.ai/api/search-image?query=indie%20music%20livehouse%20concert%20crowd%20with%20warm%20stage%20lights%20and%20hands%20raised%2C%20energetic%20atmosphere%2C%20editorial%20concert%20photography%2C%20deep%20red%20and%20amber%20tonal%20palette%2C%20slight%20grain&width=1200&height=760&seq=card-yinyue-01&orientation=landscape",
    featured: true,
    body: [
      { type: "p", text: "这个夏天，Livehouse 的周末档期几乎一票难求。不同于动辄几万人坐着的演唱会，中小型现场离舞台更近，音乐更响，观众和乐队之间也没有那么远的距离。" },
      { type: "h2", text: "为“此刻”而来的人们" },
      { type: "p", text: "对许多乐迷而言，看一场演出早已不只是听歌。它像一场约定好的集体情绪释放：当灯光暗下、前奏响起，几千人同时欢呼的那一刻，孤独感被暂时卸下。散场后大家走出门，还在热烈地讨论今晚的歌单。" },
      { type: "h2", text: "本地化演出生态正在成熟" },
      { type: "p", text: "越来越多城市拥有了自己的 Livehouse 与独立厂牌，巡演不再只停留在几座一线城市。更成熟的排期、更专业的调音与周边，让中小型演出成为年轻人在周末最想去的去处之一。" },
      { type: "p", text: "如果你还没体验过现场，不妨留意下身边最近的巡演站。有些相遇，只在当天的灯光与鼓点里成立。" },
    ],
  },
  {
    id: "tu-shu-guan-yue-du-kong-jian",
    category: "wenhua",
    title: "城市阅读地图：用一整天，把时间交给一家安静的图书馆",
    summary: "数字时代里，纸页翻动的声音反而更显珍贵。我们走访了几家风格各异的公共阅读空间，整理出一份「慢读一整天」的城市指南。",
    author: "苏牧之",
    date: "2026-08-26",
    readTime: "7 分钟",
    tags: ["阅读", "城市漫游", "公共空间"],
    image:
      "https://readdy.ai/api/search-image?query=peaceful%20modern%20library%20reading%20space%20with%20warm%20wood%20and%20natural%20light%2C%20person%20reading%20a%20book%20by%20large%20window%2C%20calm%20editorial%20photography%2C%20soft%20warm%20tones&width=1200&height=760&seq=card-wenhua-01&orientation=landscape",
    body: [
      { type: "p", text: "我们习惯在碎片时间里读完一切，却很少给自己整段沉默。这一次，把手机放进口袋，选一家离家不远的图书馆，从早到晚，只做一件事：阅读。" },
      { type: "h2", text: "为什么还需要一座物理空间" },
      { type: "p", text: "比起随时可点的电子书，图书馆提供的是「被允许慢下来」的氛围。坐满人的自习区长桌、偶尔翻书的声响、窗边洒下的光，这些微小的在场感，恰恰是独处时最需要的背景音。" },
      { type: "h2", text: "一份可复制的慢读日程" },
      { type: "p", text: "上午挑一本书、占据靠窗座位，午后在期刊区随意翻阅，傍晚把今天的摘录写进笔记本。一整天过去，你会发现：时间并没有被浪费，只是以另一种方式被郑重度过。" },
    ],
  },
  {
    id: "shen-ye-yin-yue-zhi-yu",
    category: "yinyue",
    title: "深夜电台复兴：为什么越来越多人，在睡前点开一档陪伴型播客",
    summary: "睡不着的人群，正在把耳朵交给声音。陪伴型播客如何成为新的“睡前仪式”，我们又该如何理解这种集体性的声音依恋？",
    author: "顾南星",
    date: "2026-08-23",
    readTime: "6 分钟",
    tags: ["播客", "助眠", "生活方式"],
    image:
      "https://readdy.ai/api/search-image?query=person%20listening%20to%20podcast%20in%20bed%20at%20night%20with%20headphones%20and%20dim%20warm%20lamp%20light%2C%20cozy%20bedroom%20ambience%2C%20editorial%20nighttime%20photography%2C%20soft%20tones&width=1200&height=760&seq=card-yinyue-02&orientation=landscape",
    hot: true,
    body: [
      { type: "p", text: "都市的深夜并不总是安静，尤其是内心。越来越多年轻人养成了新的睡前仪式：戴上耳机，点开一档熟悉的播客，让主持人的声音像老友一样陪自己入眠。" },
      { type: "h2", text: "声音提供的是“有人在”的错觉" },
      { type: "p", text: "心理学里有个概念叫社会在场感。当声音足够熟悉、足够松弛，大脑会暂时放下警觉，仿佛身边真的坐着一位温柔聊天的人。这正是陪伴型音频最珍贵的地方。" },
      { type: "h2", text: "选择适合你的频率" },
      { type: "p", text: "有人需要科普，有人需要故事，也有人只想听一段不赶时间的闲聊。找到那档「不用记知识点、不用发表观点」的节目，把它设为固定的睡眠开关，你会发现入睡这件事，没有想象中那么难。" },
    ],
  },
  {
    id: "dian-ying-yuan-gai-zao",
    category: "yingshi",
    title: "老影院重生：当社区影院开始放映文艺片，观众在银幕前重新坐下",
    summary: "在流媒体时代，一批改造后的社区老影院，正用策展思维把人们重新请回放映厅。本文记录几位影院主理人的坚持与观察。",
    author: "林晚晴",
    date: "2026-08-20",
    readTime: "9 分钟",
    tags: ["影院", "文艺片", "观影"],
    image:
      "https://readdy.ai/api/search-image?query=vintage%20renovated%20independent%20cinema%20with%20red%20velvet%20seats%20and%20projector%20beam%2C%20retro%20movie%20theater%20atmosphere%2C%20editorial%20photography%2C%20warm%20dramatic%20lighting&width=1200&height=760&seq=card-yingshi-02&orientation=landscape",
    featured: true,
    body: [
      { type: "p", text: "曾几何时，看电影是一件需要仪式感的事。而现在，一批把老放映厅重新装修的社区影院，正努力把这种仪式感找回来——他们不只放电影，更像在办一场场主题策展。" },
      { type: "h2", text: "从“放片子”到“做内容”" },
      { type: "p", text: "这些影院主理人会在映后组织导演连线、请影评人做分享，甚至把档期排成「城市记忆」等主题季。观众买的早已不只是座位，而是一次完整的、有人陪你理解的观影体验。" },
      { type: "h2", text: "银幕前的重逢" },
      { type: "p", text: "当一群人为了同一部片子在同一个时间来到同一间放映厅，黑暗里有共同的呼吸与笑声，这就是线上无法替代的集体感。老影院的重生，其实是一段关于陪伴的回归。" },
    ],
  },
  {
    id: "cheng-shi-man-bu-jing-ji",
    category: "shenghuo",
    title: "City Walk 之后是 Country Walk：年轻人开始把周末交还给田野",
    summary: "继城市漫步后，一种更慢的「乡村漫游」正在流行。放下导航、沿着田埂走，年轻人用脚步重新丈量生活的另一面。",
    author: "陈一舟",
    date: "2026-08-17",
    readTime: "7 分钟",
    tags: ["CityWalk", "户外", "周末"],
    image:
      "https://readdy.ai/api/search-image?query=young%20people%20walking%20on%20a%20countryside%20path%20between%20green%20fields%20at%20golden%20hour%2C%20rural%20weekend%20getaway%2C%20editorial%20lifestyle%20photography%2C%20fresh%20warm%20tones&width=1200&height=760&seq=card-shenghuo-02&orientation=landscape",
    body: [
      { type: "p", text: "城市漫步教会我们重新注视街角，而乡村漫游则在回答另一个问题：离开街道之后，我们还能走向哪里？这个答案，是一片会随风起伏的稻田，是一条没有红绿灯的土路。" },
      { type: "h2", text: "慢下来的另一重含义" },
      { type: "p", text: "Country Walk 的精髓不是远，而是慢。你不需要攻略，也不必赶路。沿着田埂走，会遇见赶鸭的老人、晾晒的农作物，和一场意料之外的日落。" },
      { type: "h2", text: "给周末一次反向选择" },
      { type: "p", text: "当城市的节奏推着我们向前，偶尔向相反方向走一走，反而能找回对时间的掌控感。找个阳光好的周末，换上舒服的鞋，去附近的郊野走一走，天地会给你答案。" },
    ],
  },
  {
    id: "tu-shu-chu-ban-zhuan-xing",
    category: "wenhua",
    title: "出版业的年轻人：他们如何用一本书，重新定义“做书”这件事",
    summary: "从独立杂志到小型出版工作室，一批年轻人正在打破“纸媒已死”的想象，用装帧、插画与社群运营，让纸质书重新变得迷人。",
    author: "苏牧之",
    date: "2026-08-14",
    readTime: "8 分钟",
    tags: ["出版", "书店", "纸媒"],
    image:
      "https://readdy.ai/api/search-image?query=independent%20bookstore%20and%20small%20publishing%20studio%20desk%20with%20zines%20magazines%20and%20handmade%20books%2C%20paper%20printing%20process%2C%20editorial%20photography%2C%20warm%20creative%20workspace%20tones&width=1200&height=760&seq=card-wenhua-02&orientation=landscape",
    body: [
      { type: "p", text: "“纸媒已死”的说法喊了很多年，可总有人不信邪。他们开小型出版工作室、做独立杂志、办主题书展，用近乎手作的方式，把一本本书送到真正喜爱它的人手里。" },
      { type: "h2", text: "装帧是第一件作品" },
      { type: "p", text: "这批年轻出版人会为内容挑选特种纸、设计腰封、埋进插画彩页。对他们来说，书的形态本身就在说话——摸得到、翻得动的质感，是数字页面给不了的触感体验。" },
      { type: "h2", text: "把读者变成同路人" },
      { type: "p", text: "通过读书会、共读计划和线下书展，他们让阅读不再孤独。纸质书的意义，也许正在于它总能成为人与人之间相遇的理由。只要还有人愿意为内容坐下来，出版就远未终结。" },
    ],
  },
  {
    id: "shi-chang-mei-shi-sui-xing",
    category: "shenghuo",
    title: "菜市场随行记：在烟火气里，重新学会买菜与吃饭",
    summary: "当外卖填满日常，有人选择回到菜市场。跟随摊主的吆喝与熟客的寒暄，我们记录下这种正在回归的、具体的烟火生活。",
    author: "顾南星",
    date: "2026-08-11",
    readTime: "6 分钟",
    tags: ["菜市场", "做饭", "生活"],
    image:
      "https://readdy.ai/api/search-image?query=lively%20traditional%20wet%20market%20with%20colorful%20fresh%20vegetables%20and%20fruit%20stalls%20in%20the%20morning%2C%20people%20shopping%2C%20warm%20documentary%20photography%2C%20vivid%20yet%20natural%20tones&width=1200&height=760&seq=card-shenghuo-03&orientation=landscape",
    body: [
      { type: "p", text: "有人觉得买菜麻烦，也有人正从菜市场里找回生活的掌控感。下班后绕去常去的那家摊子，挑两根新鲜黄瓜，和摊主闲聊几句天气——这是独居生活里难得的、具体而温暖的人际连接。" },
      { type: "h2", text: "知道食物从哪里来" },
      { type: "p", text: "在菜市场，你能看到蔬菜还带着泥土，鱼虾还在活蹦乱跳。这种「看得见的来源」让做饭不再只是加热，而是一种与季节同步的创造。什么菜当令，菜市场的摊位最清楚。" },
      { type: "h2", text: "一顿饭的自我修复" },
      { type: "p", text: "花一小时洗菜、切菜、下锅，再坐下来认真吃完。这个过程看似琐碎，却是对忙碌一天最好的整理。烟火气从不高级，却总能把人稳稳接住。" },
    ],
  },
  {
    id: "ju-ji-dang-an-ju-hui",
    category: "wenhua",
    title: "纪录片创作者的十年：他们坚持用长镜头，拍下普通人的真实",
    summary: "影像泛滥的年代，长镜头与耐心反而成为稀缺品。几位独立纪录片创作者分享他们如何用数年时间，跟拍那些值得被记住的普通人。",
    author: "周野",
    date: "2026-08-08",
    readTime: "11 分钟",
    tags: ["纪录片", "影像", "深度"],
    image:
      "https://readdy.ai/api/search-image?query=documentary%20filmmaker%20filming%20ordinary%20people%20in%20a%20small%20town%20with%20a%20cinema%20camera%2C%20quiet%20observational%20street%20scene%2C%20cinematic%20editorial%20photography%2C%20natural%20light&width=1200&height=760&seq=card-wenhua-03&orientation=landscape",
    hot: true,
    body: [
      { type: "p", text: "流量可以靠剪辑堆出来，信任却只能靠时间换回来。这一批纪录片创作者甘愿把自己「泡」进一个社区、一个家庭或一个行业数年，只为让镜头下的普通人，在银幕上活出真实的样子。" },
      { type: "h2", text: "长镜头里的尊重" },
      { type: "p", text: "当剪辑越来越快，克制却让他们慢下来。长镜头不只是一种美学，更是一种姿态：愿意等被摄者自然流露，而不是逼他们说出「正确」的话。" },
      { type: "h2", text: "被看见本身就有力量" },
      { type: "p", text: "很多受访者说，最打动他们的并非成片，而是被认真倾听的过程。记录的意义，往往不只是留给观众，更是还给那些始终在生活里努力的人一份「我值得被看见」的确认。" },
    ],
  },
  {
    id: "zao-can-wu-can-shi-pu",
    category: "shenghuo",
    title: "一人食实验：一周 7 道快手早餐，把早晨还给自己",
    summary: "不吃早餐或随便应付，正在偷走一天的节奏。我们设计了一份食材简单、十五分钟上桌的七日早餐方案，让你用一顿饭换回清晨的从容。",
    author: "陈一舟",
    date: "2026-08-05",
    readTime: "6 分钟",
    tags: ["食谱", "早餐", "快手菜"],
    image:
      "https://readdy.ai/api/search-image?query=simple%20beautiful%20breakfast%20spread%20with%20bowl%20of%20congee%2C%20eggs%20and%20steamed%20buns%20on%20a%20small%20table%20by%20morning%20window%20light%2C%20clean%20editorial%20food%20photography%2C%20fresh%20natural%20tones&width=1200&height=760&seq=card-shenghuo-04&orientation=landscape",
    body: [
      { type: "p", text: "把早晨还给自己，从一顿像样的早餐开始。一周七天，我们准备了七套「十到十五分钟」就能完成的方案：从燕麦酸奶碗到皮蛋瘦肉粥，好吃、省钱，还不费时间。" },
      { type: "h2", text: "提前十分钟，从容一整天" },
      { type: "p", text: "关键在于前一天晚上的「顺手准备」：泡好燕麦、洗好青菜、解冻好肉片。早上只做组合与加热，焦虑感会大幅下降，也能省下更多时间给真正重要的事。" },
      { type: "h2", text: "口味可以轮换，节奏不要断" },
      { type: "p", text: "刚开始不必追求花样，先把「按时吃早餐」养成习惯。等身体习惯了这份准时，再慢慢加入更多你喜欢的搭配。认真吃饭，是低成本却高回报的自我照顾。" },
    ],
  },
  {
    id: "ju-ben-gai-xie-xin-si-lu",
    category: "yingshi",
    title: "从纸页到银幕：剧本改编的得与失，原著粉该不该担心",
    summary: "改编剧年年引发讨论：到底该忠于原著，还是让位于影像语言？我们从案例出发，聊聊改编的本质与评判的新标准。",
    author: "林晚晴",
    date: "2026-08-02",
    readTime: "10 分钟",
    tags: ["改编剧", "编剧", "IP"],
    image:
      "https://readdy.ai/api/search-image?query=writing%20desk%20with%20novel%20manuscript%20and%20movie%20storyboard%20and%20cup%20of%20coffee%2C%20creative%20adaptation%20process%2C%20editorial%20photography%2C%20warm%20focused%20workspace%20lighting&width=1200&height=760&seq=card-yingshi-03&orientation=landscape",
    body: [
      { type: "p", text: "每年都有改编作品上线，也总有一批原著粉严阵以待。改编到底该「照搬」还是「重写」？与其纠结谁更忠实，不如先想清楚：媒介变了，叙事的语言也该跟着变。" },
      { type: "h2", text: "忠于「魂」，而非忠于「形」" },
      { type: "p", text: "好的改编，保留的是人物动机、主题内核与情感浓度，砍掉的则是不适合影像呈现的枝节。照单全收的「忠实」，有时反而会让节奏失控、主题涣散。" },
      { type: "h2", text: "给评价一个更宽的尺子" },
      { type: "p", text: "我们习惯用「像不像原著」来打分，却少问一句「作为一部独立的作品，它好不好看」。把尺子放宽一些，或许我们会少一些失望，也多一些惊喜。毕竟好故事，从来不止一种讲法。" },
    ],
  },
];

export const hotList: string[] = [
  "秋冬治愈系剧集清单，6 部作品陪你过慢周末",
  "现场演出正在成为年轻人的新社交方式",
  "40㎡ 小户型改造：留白与收纳让家更好住",
  "深夜播客复兴，声音成为新的睡前仪式",
  "老影院重生，观众重新坐回银幕前",
  "Country Walk：把周末交还给田野",
];

export const faqs: Faq[] = [
  { q: "看料站是做什么的？", a: "看料站是一个面向普通读者的内容聚合阅读门户，聚焦影视综艺、音乐现场、生活方式与文化社会等话题，通过人工精选与栏目整理，帮你高效找到值得一读的优质内容，并提供清晰的分类导航。" },
  { q: "站内的内容来自哪里？", a: "站内文章由看料站编辑团队策划与撰写，并参考公开的行业资讯、作品资料与公共讨论进行梳理，所有选题均遵循真实、审慎与正向的表达原则，不传播未经核实的针对个人的消息。" },
  { q: "如何订阅最新的内容？", a: "你可以在首页或页脚的订阅框填写常用邮箱，勾选感兴趣的栏目，我们会在有新内容上线时为你推送精选摘要。所有订阅均可随时取消，我们不会向你发送无关信息。" },
  { q: "我会错过某篇文章吗？", a: "不会。文章会按栏目归档，并通过热门榜与站内搜索帮助你回溯查找。也可以从文章页的“相关推荐”与“更多阅读”继续浏览同一主题的延伸内容。" },
  { q: "如何联系看料站或提出选题建议？", a: "欢迎通过邮件联系我们，或在关于我们页面填写留言。若你有值得分享的好选题、好作品线索，也非常欢迎告诉我们，我们会在核实后纳入内容规划。" },
];

export const voices: { name: string; role: string; text: string }[] = [
  { name: "米粒", role: "剧集爱好者", text: "片单质量很稳，编辑品味在线，跟着看料站的推荐基本没踩过雷，周末有了固定去处。" },
  { name: "阿杰", role: "独立音乐听众", text: "音乐现场那几篇写到了心坎里，看完就订了最近一场 Livehouse，文字真的能带动人去现场。" },
  { name: "小棠", role: "居家改造新手", text: "生活方式栏目很实在，不是空谈，照着把家里收了一遍，舒服多了。少焦虑，多生活。" },
];